'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentCreditNoteCreationRequest(number, recipient, issueDate, invoiceNumber, invoiceDate, lineItems, originOfGoods, documentaryCredit, currency, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, extraCredit, purchaseOrderReference, transportDocumentNumber) {
  this.a8g = null;
  this.a8n = null;
  this.a8e = null;
  this.a8d = null;
  this.a8c = null;
  this.a8f = null;
  this.a8h = null;
  this.a89 = null;
  this.a88 = null;
  this.a8l = null;
  this.a8k = null;
  this.a8i = null;
  this.a8j = null;
  this.a8b = null;
  this.a8a = null;
  this.a8m = null;
  this.a8o = null;
  this.a8g = number;
  this.a8n = recipient;
  this.a8e = issueDate;
  this.a8d = invoiceNumber;
  this.a8c = invoiceDate;
  this.a8f = lineItems;
  this.a8h = originOfGoods;
  this.a89 = documentaryCredit;
  this.a88 = currency;
  this.a8l = placeOfReceipt;
  this.a8k = placeOfLoading;
  this.a8i = placeOfDelivery;
  this.a8j = placeOfDischarge;
  this.a8b = incoterm;
  this.a8a = extraCredit;
  this.a8m = purchaseOrderReference;
  this.a8o = transportDocumentNumber;
}
export { $c_Lapp_data_AppDocumentCreditNoteCreationRequest as $c_Lapp_data_AppDocumentCreditNoteCreationRequest };
$p = $c_Lapp_data_AppDocumentCreditNoteCreationRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentCreditNoteCreationRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentCreditNoteCreationRequest() {
}
export { $h_Lapp_data_AppDocumentCreditNoteCreationRequest as $h_Lapp_data_AppDocumentCreditNoteCreationRequest };
$h_Lapp_data_AppDocumentCreditNoteCreationRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentCreditNoteCreationRequest)) {
    if ((this.a8g === x$0.a8g)) {
      var x = this.a8n;
      var x$2 = x$0.a8n;
      var $x_14 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$3 = this.a8e;
      var x$4 = x$0.a8e;
      var $x_13 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_13 = false;
    }
    if (($x_13 && (this.a8d === x$0.a8d))) {
      var x$5 = this.a8c;
      var x$6 = x$0.a8c;
      var $x_12 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$7 = this.a8f;
      var x$8 = x$0.a8f;
      var $x_11 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$9 = this.a8h;
      var x$10 = x$0.a8h;
      var $x_10 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$11 = this.a89;
      var x$12 = x$0.a89;
      var $x_9 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$13 = this.a88;
      var x$14 = x$0.a88;
      var $x_8 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$15 = this.a8l;
      var x$16 = x$0.a8l;
      var $x_7 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$17 = this.a8k;
      var x$18 = x$0.a8k;
      var $x_6 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$19 = this.a8i;
      var x$20 = x$0.a8i;
      var $x_5 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$21 = this.a8j;
      var x$22 = x$0.a8j;
      var $x_4 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$23 = this.a8b;
      var x$24 = x$0.a8b;
      var $x_3 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$25 = this.a8a;
      var x$26 = x$0.a8a;
      var $x_2 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$27 = this.a8m;
      var x$28 = x$0.a8m;
      var $x_1 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$29 = this.a8o;
      var x$30 = x$0.a8o;
      return ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 17;
});
$p.t = (function() {
  return "AppDocumentCreditNoteCreationRequest";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.a8g;
      break;
    }
    case 1: {
      return this.a8n;
      break;
    }
    case 2: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.a8e);
      break;
    }
    case 3: {
      return this.a8d;
      break;
    }
    case 4: {
      return this.a8c;
      break;
    }
    case 5: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.a8f);
      break;
    }
    case 6: {
      return this.a8h;
      break;
    }
    case 7: {
      return this.a89;
      break;
    }
    case 8: {
      return this.a88;
      break;
    }
    case 9: {
      return this.a8l;
      break;
    }
    case 10: {
      return this.a8k;
      break;
    }
    case 11: {
      return this.a8i;
      break;
    }
    case 12: {
      return this.a8j;
      break;
    }
    case 13: {
      return this.a8b;
      break;
    }
    case 14: {
      return this.a8a;
      break;
    }
    case 15: {
      return this.a8m;
      break;
    }
    case 16: {
      return this.a8o;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "issueDate";
      break;
    }
    case 3: {
      return "invoiceNumber";
      break;
    }
    case 4: {
      return "invoiceDate";
      break;
    }
    case 5: {
      return "lineItems";
      break;
    }
    case 6: {
      return "originOfGoods";
      break;
    }
    case 7: {
      return "documentaryCredit";
      break;
    }
    case 8: {
      return "currency";
      break;
    }
    case 9: {
      return "placeOfReceipt";
      break;
    }
    case 10: {
      return "placeOfLoading";
      break;
    }
    case 11: {
      return "placeOfDelivery";
      break;
    }
    case 12: {
      return "placeOfDischarge";
      break;
    }
    case 13: {
      return "incoterm";
      break;
    }
    case 14: {
      return "extraCredit";
      break;
    }
    case 15: {
      return "purchaseOrderReference";
      break;
    }
    case 16: {
      return "transportDocumentNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentCreditNoteCreationRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iH)));
}
export { $isArrayOf_Lapp_data_AppDocumentCreditNoteCreationRequest as $isArrayOf_Lapp_data_AppDocumentCreditNoteCreationRequest };
var $d_Lapp_data_AppDocumentCreditNoteCreationRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentCreditNoteCreationRequest, "app.data.AppDocumentCreditNoteCreationRequest", ({
  iH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentCreditNoteCreationRequest as $d_Lapp_data_AppDocumentCreditNoteCreationRequest };
//# sourceMappingURL=app.data.-App-Document-Credit-Note-Creation-Request.js.map
